module.exports = __webpack_public_path__ + "media/images/pic/saska/speaking-5442f455b18607ec9ba378f212440432.svg";